import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=17375a59&scoped=true&"
import script from "./projects.vue?vue&type=script&lang=js&"
export * from "./projects.vue?vue&type=script&lang=js&"
import style0 from "./projects.vue?vue&type=style&index=0&id=17375a59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17375a59",
  null
  
)

export default component.exports